/**
 * Filter shop (woocommerce/archive-product.php + template-parts/shop-sidebar.php).
 *
 * Dua hal:
 *
 * 1. Accordion group filter (Kategori / Harga) — berlaku di semua breakpoint.
 * 2. Penempatan sidebar per breakpoint: di bawah 992px isi sidebar
 *    (.shop-sidebar-inner) dipindah ke offcanvas penuh #site-offcanvas-shop-filter
 *    (blocks/block-offcanvas-shop-filter.php) supaya filternya tampil seperti
 *    panel pencarian, lalu dikembalikan ke <aside class="shop-sidebar"> begitu
 *    kembali ke desktop. Pola yang sama dipakai pencarian header
 *    (initCompactSearchPlacement di site-navigation.js): markup-nya tetap satu,
 *    cuma penempatan + atribut data-ss-toggle tombolnya yang ditukar, jadi tidak
 *    ada form/ID yang terduplikasi.
 *
 * Buka/tutup panelnya sendiri tetap ditangani komponen offcanvas parent theme
 * (data-ss-toggle="offcanvas"), termasuk backdrop, Escape, dan klik di luar.
 */

var PANEL_ID = "site-offcanvas-shop-filter";
// Sama dengan durasi transisi .ss-offcanvas parent theme (0.3s): isi panel baru
// dipindah balik ke sidebar setelah animasi tutupnya kelar, supaya panelnya
// tidak kelihatan kosong sambil slide keluar.
var HIDE_DURATION = 300;

function initFilterAccordion(inner) {
  inner.querySelectorAll(".sidebar-filter-group__toggle").forEach(function (toggle) {
    toggle.addEventListener("click", function () {
      var isOpen = this.getAttribute("aria-expanded") === "true";
      this.setAttribute("aria-expanded", String(!isOpen));
      this.closest(".sidebar-filter-group").classList.toggle("is-collapsed");
    });
  });
}

function initCompactPlacement(sidebar, inner, toggle, panel, panelBody) {
  var mql = window.matchMedia("(max-width: 991px)");

  function place(isCompact) {
    if (isCompact) {
      panelBody.appendChild(inner);
      toggle.setAttribute("data-ss-toggle", "offcanvas");
      toggle.setAttribute("data-ss-target", "#" + PANEL_ID);
      return;
    }

    toggle.removeAttribute("data-ss-toggle");
    toggle.removeAttribute("data-ss-target");

    // Resize ke desktop sementara panelnya masih terbuka: tutup dulu lewat
    // tombol dismiss-nya (satu-satunya pintu masuk ke komponen parent theme,
    // lihat catatan yang sama di minicart.js), baru pindahkan isinya.
    var dismiss = panel.classList.contains("ss-show")
      ? panel.querySelector('[data-ss-dismiss="offcanvas"]')
      : null;

    if (dismiss) {
      dismiss.click();
      window.setTimeout(function () {
        sidebar.appendChild(inner);
      }, HIDE_DURATION);
      return;
    }

    sidebar.appendChild(inner);
  }

  // Status tombol Filter ikut status panel; event-nya di-dispatch parent theme
  // di elemen panel saat show/hide.
  panel.addEventListener("shown.ss.offcanvas", function () {
    toggle.setAttribute("aria-expanded", "true");
  });
  panel.addEventListener("hidden.ss.offcanvas", function () {
    toggle.setAttribute("aria-expanded", "false");
  });

  place(mql.matches);
  mql.addEventListener("change", function (event) {
    place(event.matches);
  });
}

export function initShopFilter() {
  var sidebar = document.getElementById("shop-sidebar");
  var inner = sidebar && sidebar.querySelector(".shop-sidebar-inner");
  if (!sidebar || !inner) return;

  initFilterAccordion(inner);

  var toggle = document.getElementById("shop-filter-toggle");
  var panel = document.getElementById(PANEL_ID);
  var panelBody = panel && panel.querySelector(".dufeng-offcanvas-filter__body");
  if (!toggle || !panel || !panelBody) return;

  initCompactPlacement(sidebar, inner, toggle, panel, panelBody);
}
